import TrueFalseQuestionTemplate from '~/pages/anatomyV2/libs/components/TrueFalseQuestionTemplate'
import {
  waterDigestionPNG,
  waterDigestionWEBP,
} from '~/pages/anatomyV2/waterDigestion/constants'
import { COLORS } from '~/shared/constants/uiConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 2

const WaterDigestionAnatomyV2 = (props: TPageProps) => (
  <TrueFalseQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.waterDigestion.title"
    factI18nKey="onboarding.waterDigestion.fact"
    questionImagePNG={waterDigestionPNG}
    questionImageWEBP={waterDigestionWEBP}
    questionImageAlt="Drinking water during meals"
    question="Spot the fake: water and digestion"
    cardBackground="#FFD387"
    firstBehindColor={COLORS.PURPLE_100}
    secondBehindColor={COLORS.WHITE}
  />
)

export default WaterDigestionAnatomyV2
